import { createTheme, Theme } from '@mui/material/styles';
import { yellow, blue } from '@mui/material/colors';

declare module '@mui/styles/defaultTheme' {
  interface DefaultTheme extends Theme {}
}

const theme = createTheme({
  spacing: (factor: number) => `${factor * 8}px`,
   palette: {
    primary: {
      main: yellow[500]
    },
    secondary: {
      main: blue[500]
    }
  },
});

export default theme;